import { Link } from "react-router-dom";
import { CONTACT, DISCLAIMER } from "@/data/site";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy-deep text-cream">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-24 pb-10">
      <p className="font-serif text-[13vw] lg:text-[9rem] leading-none font-light text-cream/10 select-none whitespace-nowrap" aria-hidden="true">
        Annwil Law Ja
      </p>

      <div className="grid md:grid-cols-3 gap-14 mt-4 border-t border-cream/15 pt-14">
        <div>
          <span className="block h-16 w-16 rounded-full overflow-hidden border border-cream/20 bg-white mb-5">
            <img src="/annwil-logo.png" alt="Annwil Law Ja logo" className="w-full h-full object-cover" />
          </span>
          <p className="font-serif text-2xl mb-4">Annwil Law Ja</p>
          <p className="text-cream/70 text-sm leading-relaxed max-w-xs">
            Your trusted legal partner for family law, real estate law, probate
            and estate planning — advising clients across Jamaica and
            throughout the diaspora.
          </p>
        </div>
        <nav aria-label="Footer navigation">
          <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Explore</p>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-home-link" className="text-cream/80 hover:text-gold transition-colors duration-300" to="/">Home</Link></li>
            <li><Link data-testid="footer-services-link" className="text-cream/80 hover:text-gold transition-colors duration-300" to="/services">Services</Link></li>
            <li><Link data-testid="footer-about-link" className="text-cream/80 hover:text-gold transition-colors duration-300" to="/about">About</Link></li>
            <li><Link data-testid="footer-contact-link" className="text-cream/80 hover:text-gold transition-colors duration-300" to="/contact">Contact &amp; Consultation</Link></li>
          </ul>
        </nav>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Contact</p>
          <ul className="space-y-3 text-sm text-cream/80">
            <li>
              <a data-testid="footer-phone-link" href={CONTACT.phoneHref} className="hover:text-gold transition-colors duration-300">
                {CONTACT.phone}
              </a>
            </li>
            <li>
              <a data-testid="footer-email-link" href={CONTACT.emailHref} className="hover:text-gold transition-colors duration-300 break-all">
                {CONTACT.email}
              </a>
            </li>
            <li>
              {CONTACT.addressLines[0]}
              <br />
              {CONTACT.addressLines[1]}
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-cream/15 mt-14 pt-8 flex flex-col md:flex-row justify-between gap-6">
        <p className="text-xs text-cream/50">
          © {new Date().getFullYear()} Annwil Law Ja. All rights reserved.
        </p>
        <p data-testid="footer-disclaimer" className="text-xs text-cream/50 max-w-xl leading-relaxed">
          {DISCLAIMER}
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
